import { render, staticRenderFns } from "./ParticleAnimation.vue?vue&type=template&id=a1322c9c&scoped=true"
import script from "./ParticleAnimation.vue?vue&type=script&lang=js"
export * from "./ParticleAnimation.vue?vue&type=script&lang=js"
import style0 from "./ParticleAnimation.vue?vue&type=style&index=0&id=a1322c9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1322c9c",
  null
  
)

export default component.exports